/* eslint-disable */
import { saveAs } from 'file-saver'
import * as XLSX from 'xlsx'


/** 导出文件
 * @param column [{ lable: 表头名称, width: 表格中的宽度 }]
 * @param dataList 数据源
 * @param filename 文件名称
 * @param bookType 文件类型 默认xlsx
 * */
export function exportToExcel({column=[],dataList,filename, bookType = 'xlsx'}) {
  filename = filename || 'excel-list'
  // 转换数据为工作表对象
  const worksheet = XLSX.utils.json_to_sheet(dataList);

    // 自定义表头名称和顺序
    //const header = ['字段1', '字段2', '字段3'];
    const header =column.map(x => x?.lable) ?? []
    for (let i = 0; i < header.length; i++) {
      const columnName = XLSX.utils.encode_col(i);
      worksheet[columnName + '1'].v = header[i];
    }

  // 设置列宽
  //const columnWidths = [20, 15, 30]; // 默认列宽度
  const columnWidths =column.map(x => x?.width) ?? []
  for (let i = 0; i < columnWidths.length; i++) {
    const columnWidth = columnWidths[i] || 10; // 若传入宽度为空，则使用默认值
    worksheet['!cols'] = worksheet['!cols'] || [];
    worksheet['!cols'][i] = { 
      wch: columnWidth ,
      alignment: {
      wrapText: true,
      horizontal: 'left',
    },};
  }
  
  // 处理单元格的值保持原始数据类型
  const range = XLSX.utils.decode_range(worksheet['!ref']);
  for (let R = range.s.r + 1; R <= range.e.r; ++R) {
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
      const cellValue = worksheet[cellAddress];
      cellValue.t = 's'; // 将单元格值的类型设置为字符串类型
      cellValue.v = XLSX.utils.format_cell(cellValue); // 使用格式化函数获取原始值
    }
  }

  // 创建工作簿对象并将工作表添加到其中
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

  // 导出Excel文件
  XLSX.writeFile(workbook, `${filename}.${bookType}`);

}
